import dayjs from 'dayjs'

export function creditDatePassed(value, now = new Date()) {
  if (!value) return false
  return dayjs(now).isAfter(dayjs(value))
}

/** Credits that can still be used. A passed expiry date counts as none. */
export function visibleGameCredits(user, now = new Date()) {
  if (!user) return 0

  const institution =
    user.institution && typeof user.institution === 'object'
      ? user.institution
      : null

  if (institution) {
    if (creditDatePassed(institution.creditsExpire, now)) return 0
    return Number(institution.credits) || 0
  }

  if (creditDatePassed(user.creditsExpire, now)) return 0
  return Number(user.credits) || 0
}
